export default function Twitter({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.276"
      height="17.355"
      viewBox="0 0 20.276 17.355"
      {...props}
    >
      <path d="M18.136 2.998a5.016 5.016 0 0 0 1.59-2.159 8.492 8.492 0 0 1-2.572.764 4.24 4.24 0 0 0-7.347 3.969h-.033C3.493 5.14.941 1.11.941 1.11a5.164 5.164 0 0 0 .968 5.705 2.526 2.526 0 0 1-1.438-.366s-.525 2.722 2.9 4.187a4.731 4.731 0 0 1-1.5.164 4.584 4.584 0 0 0 3.88 2.9s-1.282 1.623-5.758 1.937a11.931 11.931 0 0 0 18.135-9.7l2.141-3.421Z" />
    </svg>
  );
}
